module.exports = __webpack_public_path__ + "static/cases-text-f925c3ff008a815c3d6201dbbede1067.svg";